<template>
  <b-modal
    size="md"
    @shown="limpaModal"
    :id="'ModalImportacao'"
    :no-close-on-backdrop="loadingImportar"
    :no-close-on-esc="loadingImportar"
  >
    <LoadingPadraoContainer
      v-if="loadingImportar"
      class="loading-padrao-backdrop"
      background
      :fraseLoading="['Importando produtos', 'Aguarde um momento']"
      delay="5000"
      classe="verde"
    />
    <Header
      mini
      icone="file-upload"
      titulo="Importação do cadastro de produtos"
      cor="verde"
      slot="modal-header"
    />
    <template>
      <div class="modal-corpo">
        <div class="download-mensagem-planilha">
          Clique para baixar o arquivo que contém os campos de preenchimento e suas instruções.
        </div>
        <div class="botao-download-container">
          <a href="/docs/gabarito-produtos-rte.xlsx">
            <button class="botao-download">
              <img src="@/assets/images/images/xlsx.svg" />
            </button>
            <div>gabarito_rte.xlsx</div>
          </a>
        </div>
        <div class="download-mensagem-planilha">
          Após salvar o arquivo em seu computador, no campo abaixo basta clicar no botão 'Carregar
          arquivo', selecione seu arquivo para importação e clique em 'Importar'.
        </div>
        <div class="form-importar-wrapper">
          <!-- <div>{{ nomeArquivo }}</div> -->
          <div class="form-importar-input" @click="upload">
            <CenarioInput
              tipo="texto"
              placeholder="Selecione o arquivo"
              :model="nomeArquivo"
              readonly
              @update:model="update => (nomeArquivo = update)"
            />
          </div>
          <BotaoPadrao
            arredondadoDireita
            nome="Escolher arquivo"
            icone="upload"
            :click="upload"
            cor="verde"
          />
        </div>
        <div class="esconde-form">
          <b-form-file
            @change="obterNomeArquivo"
            v-model="file"
            accept=".xlsx"
            ref="xlsInput"
            name="file"
            placeholder="CLIQUE PARA SELECIONAR"
            browse-text="Carregar arquivo"
          />
        </div>
      </div>
      <div v-if="mensagem" class="mensagem-erro">
        <div class="mensagem-erro-container">
          <div v-for="(item, index) in mensagem" :key="index">
            {{ item }}
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :click="closeModal"
        :desabilita="loadingImportar"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Importar"
        icone="check"
        :click="importar"
        cor="verde"
        :desabilita="!file || loadingImportar"
      />
    </template>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";
import CenarioInput from "../CenarioInput/CenarioInput.vue";
import ApiImportador from "@/services/importador.js";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

import { mapGetters } from "vuex";

export default {
  name: "ModalImportacao",
  components: {
    BotaoPadrao,
    Header,
    CenarioInput,
    LoadingPadraoContainer
  },
  props: {
    onClickImportar: Function
  },
  inject: ["pushAlert"],
  data() {
    return {
      file: "",
      nomeArquivo: "",
      loadingImportar: false,
      mensagem: ""
    };
  },
  computed: {
    ...mapGetters("empresa", ["getEmpresa"])
  },
  methods: {
    limpaModal() {
      this.mensagem = "";
      this.file = "";
      this.nomeArquivo = "";
    },
    obterNomeArquivo(event) {
      let file = event.target.files[0];
      if (event.type == "change") {
        this.nomeArquivo = file ? file.name : "";
      } else {
        this.nomeArquivo = "Arquivo selecionado";
      }
    },
    handleKey(event) {
      let modal = document.getElementById("ModalImportacao");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.handleClick();
        }
      }
    },
    closeModal() {
      this.$root.$emit("bv::hide::modal", "ModalImportacao");
    },
    upload() {
      this.$refs.xlsInput.$el.querySelector('input[type="file"]').click();
    },
    async importar() {
      if (this.file != "" && typeof this.file !== "undefined" && this.file != null) {
        this.loadingImportar = true;

        let form = new FormData();
        form.append("arquivo", this.file);
        form.append("idEmpresa", this.getEmpresa.id);
        try {
          const response = await new ApiImportador().file("/importador/importarProdutosRTE", form);
          if (response.status) {
            this.$root.$emit("bv::hide::modal", "ModalImportacao");
            this.$emit("atualiza");
            this.pushAlert("Produtos importados com sucesso!", "success");
          } else {
            this.mensagem = response.response;
            this.pushAlert("Erro ao importar produtos!", "danger");
          }
        } catch (error) {
          console.error(error);
          this.pushAlert("Erro ao importar produtos!", "danger");
        }
        this.loadingImportar = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.botao-download-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 8px;
  > a {
    &:hover {
      .botao-download {
        transform: scale(1.2);
      }
    }
  }
}
.botao-download {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10px 20px;
  position: relative;
  transition: transform 0.3s ease;
  img {
    width: 70px;
    height: 70px;
    cursor: pointer;
  }
}
.download-mensagem-planilha {
  margin: 0 50px;
}
.esconde-form {
  // display: none;
  position: absolute;
  bottom: 12px;
  left: 65px;
  width: 220px;
  opacity: 0;
}
.form-importar-wrapper {
  display: flex;
  justify-content: center;
  margin: 10px 50px 0 50px;
}
.form-importar-input {
  width: 100%;
}
.mensagem-erro {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  margin-top: 14px;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 10px;
}
.loading-modal-importacao {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #00000060;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--branco);
  font-size: 40px;
}
.mensagem-erro-container {
  overflow: auto;
  min-height: 20px;
  max-height: calc(100vh - 600px);
}
</style>
